import * as React from 'react';
import Slider from '@mui/material/Slider';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';


const PrettoSlider = styled(Slider)({
    color: '#F48A21',
    height: 5,
    '& .MuiSlider-track': {
        border: 'none',
    },
    '& .MuiSlider-thumb': {
        height: 20,
        width: 20,
        backgroundColor: '#12355F',
        border: '2px solid #12355F',
        '&:focus, &:hover, &.Mui-active, &.Mui-focusVisible': {
            boxShadow: 'inherit',
        },
        '&:before': {
            display: 'none',
        },
    },
    '& .MuiSlider-valueLabel': {
        lineHeight: 1.2,
        fontSize: 10,
        background: 'unset',
        padding: 0,
        width: 30,
        height: 30,
        borderRadius: '50% 50% 50%',
        backgroundColor: '#12355F',
        transformOrigin: 'bottom left',
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&:before': { display: 'none' },
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(50%, -70%) rotate(-45deg) scale(1)',
        },
        '& > *': {
            transform: 'rotate(45deg)',
        },
    },
    // Stagger the value labels when thumbs are close
    '& .MuiSlider-thumb:nth-of-type(1) .MuiSlider-valueLabel': {
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(50%, -90%) rotate(-45deg) scale(1)',
        },
    },
    '& .MuiSlider-thumb:nth-of-type(2) .MuiSlider-valueLabel': {
        transform: 'translate(50%, -100%) rotate(-45deg) scale(0)',
        '&.MuiSlider-valueLabelOpen': {
            transform: 'translate(50%, -50%) rotate(-45deg) scale(1)',
        },
    },
});




export default function CustomizedSlider(props) {
    const { low, high, keyName, customMethod, min, max, type } = props;

    const handleChange = (event, newValue) => {
        customMethod({ keyName, filterRange: newValue })
    }

    const formatValue = (value) => {
        if (type === 'amount') {
            if (value >= 100000) {
                return `${(value / 100000).toFixed(value % 100000 === 0 ? 0 : 1)}L`;
            } else if (value >= 1000) {
                return `${(value / 1000).toFixed(value % 1000 === 0 ? 0 : 1)}k`;
            }
        }
        return value;
    };

    // Check if range values are too close
    const isRangeClose = Math.abs(high - low) < (max - min) * 0.1;

    return (
        <Box sx={{ width: 'full' }}>
            <div className='px-2'>
                <PrettoSlider
                    aria-label="Always visible"
                    valueLabelDisplay="on"
                    defaultValue={[low, high]}
                    min={min}
                    max={max}
                    onChange={handleChange}
                    valueLabelFormat={formatValue}
                />
                {isRangeClose && (
                    <div className="flex justify-between mt-4 text-xs text-gray-600 pb-3">
                        <span className=' text-font12 text-white bg-gray-600 px-2 py-1 rounded-3px'>{formatValue(low)}</span>
                        <span className=' text-font12 text-white bg-gray-600 px-2 py-1 rounded-3px'>{formatValue(high)}</span>
                    </div>
                )}
            </div>
        </Box>
    );
}